//
//
//
//
//
//
//
//
//
//
//
//
//

import {appBaseUrl} from "../utils/commons";

export default {
  name: "app-header",
  data() {
    return {
      searchData: {},
    }
  },
  /**
   *left==arrow   头部搜索为箭头图标
   * left==person  头部搜索为头像图标
   * label    对应searchData的key值
   **/
  props:['placeholder','label','left'],

  methods: {
    backLastPage(){
      if(this.$store.state.device === 'wap'){
        this.$router.go(-1);
      }else{
        document.location = "http://action:10002/?";
      }
    },
    blurHanlder(){
      if(this.searchData[this.label]){
        this.$emit('on-search',this.searchData)
      }
    },
    // 跳转到个人设置页
    goUserSetting(){
      if(this.$route.meta && this.$route.meta.driver){
        this.$router.push('/driver/mine');
      }else{
        this.$router.push('/home/mine');
      }
    },
    clear(){
      this.searchData[this.label]=null;
      this.$emit('on-clear')
    },
    searchList(){
      this.$emit('on-search',this.searchData)
    },



  },



}



// WEBPACK FOOTER //
// ./src/components/app-header.vue